
export const headerSty = {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "14.52px",
    letterSpacing: "0.03em",
    textAlign: "center",
    // color: theme.palette.neutral.main,
  };
 export const contentSty = {
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "11px",
    color: "#0A2240",
    padding: "8px",
    cursor: "pointer",
  };
